import alasql from 'alasql';
import _ from 'lodash';
import * as diffUtils from './diffUtils';

export function clubRegInfo(data) {
  let result = alasql(`
    SEARCH / AS @club
      RETURN (
        @club->id AS KlubbId,
        @club->club_name AS KlubbNavn,
        @club->active_reg AS AktivPaamelding2,
        @club->contact_person AS Kontaktperson_Navn,
        @club->contact_phone_number AS Kontaktperson_Tlf,
        @club->contact_email AS Kontaktperson_Epost,
        @club->address AS Kontaktperson_Adresse,
        @club->municipality AS Kontaktperson_Kommune,
        @club->county AS Kontaktperson_Fylke,
        @club->zip AS Kontaktperson_Postnummer,
        @club->country AS Kontaktperson_Land,
        @club->billing_contact_person AS Fakturaadresse_Navn,
        @club->billing_email AS Fakturaadresse_Epost,
        @club->billing_address AS Fakturaadresse_Adresse,
        @club->billing_municipality AS Fakturaadresse_Kommune,
        @club->billing_county AS Fakturaadresse_Fylke,
        @club->billing_zip AS Fakturaadresse_Postnummer,
        @club->billing_country AS Fakturaadresse_Land,
        @club->comment AS Kommentar
      )
    FROM ?
  `, [data]);

  return alasql(`
      SELECT *,
      CASE AktivPaamelding2
        WHEN true THEN 'Påmeldt'
        WHEN false THEN 'Ikke Påmeldt'
      END as AktivPaamelding,
      CASE Tidligere_AktivPaamelding2
        WHEN true THEN 'Påmeldt'
        WHEN false THEN 'Ikke Påmeldt'
      END as Tidligere_AktivPaamelding
      REMOVE COLUMNS AktivPaamelding2, Tidligere_AktivPaamelding2
      FROM ?
    `, [result]);
}

const INFO_CHANGE_FIELDS = {
  'EndringsStatus': 'Uendret',
  'Tidligere_AktivPaamelding': '#N/A',
  'Tidligere_KlubbNavn': '#N/A',
  'Tidligere_Kommentar': '#N/A',
  'Tidligere_Kontaktperson_Navn': '#N/A',
  'Tidligere_Kontaktperson_Tlf': '#N/A',
  'Tidligere_Kontaktperson_Epost': '#N/A',
  'Tidligere_Kontaktperson_Adresse': '#N/A',
  'Tidligere_Kontaktperson_Kommune': '#N/A',
  'Tidligere_Kontaktperson_Fylke': '#N/A',
  'Tidligere_Kontaktperson_Postnummer': '#N/A',
  'Tidligere_Kontaktperson_Land': '#N/A',
  'Tidligere_Fakturaadresse_Navn': '#N/A',
  'Tidligere_Fakturaadresse_Adresse': '#N/A',
  'Tidligere_Fakturaadresse_Epost': '#N/A',
  'Tidligere_Fakturaadresse_Kommune': '#N/A',
  'Tidligere_Fakturaadresse_Fylke': '#N/A',
  'Tidligere_Fakturaadresse_Postnummer': '#N/A',
  'Tidligere_Fakturaadresse_Land': '#N/A',
};

/*
* Team Members
*/
export function changesToClubReg(detailsDiff, previousData) {
  let result = [];
  _.forEach(detailsDiff, (value, key) => {
    let changed_object = null;
    if (diffUtils.isNew(value)) {
      changed_object = addNew(value);
    } else if (diffUtils.isDeleted(value)) {
      changed_object = addDeleted(value);
    } else if (diffUtils.hasChanged(value)) {
      let item = previousData[Number(key)];
      changed_object = addChanges(item, value);
    } else {
      return;
    }
    result.push(changed_object);
  });
  return result;
}

export function addDeleted(changes) {
  return {
    ...changes[0],
    ...INFO_CHANGE_FIELDS,
    EndringsStatus: 'Slettet',
  };
}

export function addNew(changes) {
  return {
    ...changes[0],
    ...INFO_CHANGE_FIELDS,
    EndringsStatus: 'Ny',
  };
}

function updateTeam(item, changes) {
  _.forEach(changes, (change, key) => {
    item['Tidligere_' + key] = item[key];
    item[key] = change[0];
  });
  return item;
}

export function addChanges(item, changes) {
  if (!item) {
    return;
  }
  let result = {
    ...item,
    ...INFO_CHANGE_FIELDS,
    EndringsStatus: 'Endret'
  };
  result = updateTeam(result, changes);
  return result;
}



/** WEBPACK FOOTER **
 ** ./src/containers/events/reports/sql/clubReg.js
 **/